import type { IntlShape } from 'react-intl/src/types';

import type { MyOrderLineFragment } from '@/graphql/saleor/api';
import { findMediaByShotType, getTranslatedProductName } from '@/lib/product';
import * as WM from '@/views/WatchView/components/Warranty/components/WarrantyDetails/messages';

import Warranty2Years from '@/assets/warranty-2-years.svg';
import Warranty3Years from '@/assets/warranty-3-years.svg';

export const getWarrantyOrderLineDetails = (
  line: MyOrderLineFragment,
  orderLines: MyOrderLineFragment[],
  formatMessage: IntlShape['formatMessage'],
  showTranslatedProductName = true,
) => {
  const translatedProductName = line?.variant?.product
    ? getTranslatedProductName(line?.variant?.product)
    : '';
  let productName =
    showTranslatedProductName && translatedProductName
      ? translatedProductName
      : line?.productName;
  const soldierImage = findMediaByShotType(
    line?.variant?.product?.media ?? [],
    'Soldier',
  );
  let thumbnail = soldierImage ?? line?.variant?.product.thumbnail;
  const productTypeName = line?.variant?.product?.productType?.name;
  const isWarrantyExtension = productTypeName === 'Warranty';
  if (isWarrantyExtension) {
    const separateWarrantyDuration = line?.warrantyDuration;

    const parentWatchRef = line?.relatedProductWatchId;

    const parentWatch = orderLines.find((line) => line.id === parentWatchRef);
    const warrantyDuration =
      separateWarrantyDuration || parentWatch?.warrantyDuration;
    const warrantyExtDurationYears = formatMessage(WM.defined.years, {
      warrantyExtDuration: warrantyDuration,
    })
      ?.replace(/^\+/, '')
      ?.toLowerCase();

    productName = `${productName} (${warrantyExtDurationYears})`;
    thumbnail = {
      alt: productName,
      url: productName?.includes('3') ? Warranty3Years : Warranty2Years,
    };
  }
  return {
    productName,
    thumbnail,
  };
};
